import { type FC } from 'react'

import { ProductCarouselGalleryImage } from './ProductCarouselGalleryImage'
import { type ProductCarouselGalleryImageItemProps } from './ProductCarouselGalleryImageItemProps'
import { ProductCarouselGalleryItem } from './ProductCarouselGalleryItem'

const ProductCarouselGalleryImageItem: FC<
  ProductCarouselGalleryImageItemProps
> = ({
  alt,
  image,
  index,
  lazy,
  onClick,
  onScrolledInView,
  useLargeSizes,
  zoomEnabled,
}) => {
  return (
    <ProductCarouselGalleryItem
      image={image}
      index={index}
      onClick={onClick}
      onScrolledInView={onScrolledInView}
      zoomEnabled={zoomEnabled}
    >
      <ProductCarouselGalleryImage
        alt={alt}
        lazy={lazy}
        source={image}
        useLargeSizes={useLargeSizes}
      />
    </ProductCarouselGalleryItem>
  )
}

export { ProductCarouselGalleryImageItem }
